import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

class InsertLink extends React.Component {

    constructor() {
        super();

        this.handleChange = this.handleChange.bind(this);
        this.insertContent = this.insertContent.bind(this);

        this.state = {
            titulo: '',
            descricao: '',
            uri: ''
        }

    }

    handleChange(e) {
        e.preventDefault();
        const _name = e.target.name, _value = e.target.value;
        this.setState({ [_name]: _value })
    }

    insertContent() {
        const { titulo, descricao, uri } = this.state;
        this.props.insert({ titulo, descricao, uri, tipo: 5 })
    }

    render() {
        return (
            <Modal isOpen={this.props.isOpen} toggle={this.props.toggle}>
                <ModalHeader toggle={this.props.toggle}>
                    Incluir link
                </ModalHeader>
                <ModalBody>
                    <div className='row'>
                        <div className='col-12 pb-2'>
                            <label>Título</label>
                            <input name="titulo" type="text" className="form-control" onChange={this.handleChange} autoComplete="off" value={this.state.titulo} />
                        </div>
                        <div className='col-12'>
                            <label>Descrição</label>
                            <input name="descricao" type="text" className="form-control" onChange={this.handleChange} autoComplete="off" value={this.state.descricao} />
                        </div>
                        <div className='col-12 py-2'>
                            <label>URI</label>
                            <input name="uri" type="text" className="form-control" onChange={this.handleChange} autoComplete="off" value={this.state.uri} />
                        </div>
                        {this.props.loading ? (
                            <div className="col-12 text-right pt-2">
                                <div className="spinner-border text-primary" role="status" />
                            </div>
                        ) : (
                            <div className='col-12 text-right pt-2'>
                                <button className='btn btn-outline-success' onClick={this.insertContent} disabled={!this.state.titulo || !this.state.descricao || !this.state.uri}>Incluir</button>
                            </div>
                        )}

                    </div>

                </ModalBody>
            </Modal>
        );
    }
}

export default InsertLink;